import { createFileRoute, useParams } from '@tanstack/react-router';

import { WorkspaceEngagementResourceDetailScreen } from '@/features/engagement-resources/components/WorkspaceEngagementResourceDetailScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/engagement/resources/$id')({
  beforeLoad: () => {
    requirePermission('engagement:read');
  },
  component: ClinicalEngagementResourceDetailRoute,
  staticData: { crumb: 'Resource' },
});

function ClinicalEngagementResourceDetailRoute() {
  const { id } = useParams({ from: '/app/engagement/resources/$id' });
  return <WorkspaceEngagementResourceDetailScreen id={id} surface="clinical" />;
}
